import { SortHistory } from "./SortHistory";
import { Line, getElementAtEvent } from "react-chartjs-2";
import ConvertTimeStamp from "../Utils/ConvertTimeStamp";
import {
  Chart as ChartJS,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle,
} from "chart.js";

import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

function LineGraph(props) {
  const navigate = useNavigate();
  const chartRef = useRef();
  ChartJS.register(
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip,
    SubTitle
  );

  var labels = [];
  var links = [];
  var data = [];
  var arr = SortHistory(props.History);

  for (let i = 0; i < arr.length; i++) {
    labels.push(
      `Score: ${i + 1} on ${ConvertTimeStamp(arr[i].dateStr, false)}`
    );
    links.push(arr[i].dateStr);
    data.push(arr[i].score);
  }

  const state = {
    labels: labels,
    datasets: [
      {
        label: "Score",
        borderColor: "#040D41",
        backgroundColor: "#040D41",
        borderWidth: 2,
        data: data,
        pointStyle: "rect",
        pointHoverRadius: 10,
      },
    ],
  };
  const options = {
    scales: {
      y: { beginAtZero: true, max: 1450 },
    },
    responsive: true,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: "Score History",
        font: { size: "20vw" },
      },
    },
  };

  const onClick = (event) => {
    var clicked = getElementAtEvent(chartRef.current, event)[0].index;
    if (clicked !== undefined) {
      // console.log(`Score: ${labels[clicked]} : ${data[clicked]}`);
      var dateStr = links[clicked].toString(); //.split(" on ")[1];
      // console.log(dateStr);
      navigate(`/score/${dateStr.replaceAll("/", "X")}`);
    }
  };

  if (props.History !== undefined && data.length > 1)
    return (
      <div className=" OverviewContainer">
        <Line ref={chartRef} onClick={onClick} data={state} options={options} />
      </div>
    );
  return <></>;
}

export default LineGraph;
